import { useEffect, useMemo, useState } from "react";

import { usageSourceCode } from "helpers/Sources/createSource";

import {
    CRM_USAGE_LABEL,
    DEFAULT_USAGE_LABEL_BY_SOURCE_TYPE,
} from "../SourceCreation.constants";
import { getUsageOptions } from "../SourceCreation.helpers";

/**
 * Loads the usage types available for the selected source type and
 * pre-selects the default one (Web / App / Offline).
 */
const useUsageTypes = ({ sourceType }) => {
    const [usageTypes, setUsageTypes] = useState([]);
    const [usage, setUsage] = useState([]);

    useEffect(() => {
        if (!sourceType) return undefined;
        let isCancelled = false;

        const fetchUsageTypes = async () => {
            const response = await usageSourceCode(sourceType);
            if (!response?.status || isCancelled) return;

            const types = response?.data ?? [];
            setUsageTypes(types);

            const defaultLabel = DEFAULT_USAGE_LABEL_BY_SOURCE_TYPE[sourceType];
            const defaultUsageId = types.find(
                (item) => item?.name === defaultLabel,
            )?.id;
            setUsage(defaultUsageId ? [defaultUsageId] : []);
        };

        fetchUsageTypes();
        return () => {
            isCancelled = true;
        };
    }, [sourceType]);

    const usageOptions = useMemo(
        () => getUsageOptions(usageTypes),
        [usageTypes],
    );

    const crmUsageIds = useMemo(
        () =>
            usageTypes
                .filter((item) => item?.name === CRM_USAGE_LABEL)
                .map((item) => item?.id),
        [usageTypes],
    );

    return { usageOptions, crmUsageIds, usage, setUsage };
};

export default useUsageTypes;
